import type { WavespeedModelConfig } from './types';
import { xaiConfigs } from './configs/xai';
import { googleConfigs } from './configs/google';
import { openaiConfigs } from './configs/openai';
import { recraftConfigs } from './configs/recraft';
import { ideogramConfigs } from './configs/ideogram';
import { fluxConfigs } from './configs/flux';
import { kreaConfigs } from './configs/krea';
import { lumaConfigs } from './configs/luma';
import { nvidiaConfigs } from './configs/nvidia';
import { alibabaConfigs } from './configs/alibaba';
import { klingConfigs } from './configs/kling';
import { bytedanceConfigs } from './configs/bytedance';
import { microsoftConfigs } from './configs/microsoft';
import { miscConfigs } from './configs/misc';
import { topazConfigs } from './configs/topaz';
import { reveConfigs } from './configs/reve';

export { wavespeedStatusMapping } from './status-mapping';

/**
 * 模型配置映射
 */
export const wavespeedModelConfigs: Record<string, WavespeedModelConfig> = {
    ...xaiConfigs,
    ...googleConfigs,
    ...openaiConfigs,
    ...recraftConfigs,
    ...ideogramConfigs,
    ...fluxConfigs,
    ...kreaConfigs,
    ...lumaConfigs,
    ...nvidiaConfigs,
    ...alibabaConfigs,
    ...klingConfigs,
    ...bytedanceConfigs,
    ...microsoftConfigs,
    ...miscConfigs,
    ...topazConfigs,
    ...reveConfigs,
};